module.exports = __webpack_public_path__ + "img/icon-implantation-11.255b8ef1.svg";